import { MODAL, LANGUAGE } from './types';

export const setOpenModal1 = content => ( { type: MODAL.SET_MODAL_OPEN, payload: content } );
export const setCloseModal = () => ( { type: MODAL.SET_CLOSE_MODAL } );

export const setLanguage = value => {
	localStorage.setItem('sub_lang', value)
	return { type: LANGUAGE.SET_LANGUAGE, payload: value}
};

